import { currencyFormat, formatCifra } from "../repositories/utils";
import { getProductAdminList } from "../repositories/dataRetrieve";
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { CircularProgress,
        CardActionArea,
        CardContent,
        Typography,
        Divider,
        Paper,
        Card,
        Chip,
        Box } from '@mui/material';
import Carousel from 'react-material-ui-carousel';
import Image from "../static/ImagesProvider";

const CommonAdminViewPage = () => {
    const navigate = useNavigate();
    const [productList, setProductList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const getProducts = async () => {
            setIsLoading(true);
            const resp = await getProductAdminList();

            if (resp?.message?.toUpperCase() === "OK") {
                setProductList(resp?.data);
                setIsLoading(false);
            } else {
                setProductList([]);
                setIsLoading(false);
            };
        };

        getProducts();
    }, []);

    return (
        <Box
            sx={{
                backgroundColor: 'rgba(217, 217, 217, 0.5)',
                margin: 'auto',
                marginTop: {xs: '2vh', md:'5vh'},
                marginBottom: {xs: '2vh', md:'5vh'},
                height: {xs: '85vh', md:'80vh'},
                width: '90vw',
                borderRadius: '20px',
                overflowY: 'auto'
            }}
        >
            <Box sx={{ display: { xs: 'none', md: 'flex'} }}>
                <Typography
                    width='60%'
                    variant="h3"
                    component="div"
                    sx={{
                        justifyContent: 'left',
                        color: 'dimgray',
                        fontFamily: 'Barlow',
                        margin: '1rem'
                    }}
                >
                    Vista de artículos registrados
                </Typography>
            </Box>
            <Box sx={{ display: { xs: 'flex', md: 'none'} }}>
                <Typography
                    width='85%'
                    variant='h5'
                    component="div"
                    sx={{
                        justifyContent: 'left',
                        color: 'dimgray',
                        fontFamily: 'Barlow',
                        margin: '1rem'
                    }}
                >
                    Vista de artículos registrados
                </Typography>
            </Box>

            <Divider sx={{ border: '1px #000 solid', width: '90%', justifySelf: 'center', marginBottom: { xs: "2rem", md: "3rem"} }} />

            {isLoading ?
                <Typography
                    variant="h2"
                    component="div"
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        color: 'dimgray',
                        fontFamily: 'Barlow',
                        height: '70vh',
                        placeItems: 'center'
                    }}
                >
                    <CircularProgress sx={{ width: "70px !important", height: "70px !important", color: "#62C21B" }} />
                </Typography>
            :
                <>
                    {productList.length > 0 ?
                        <Box
                            sx={{
                                width: {xs: '90%', md: '96%'},
                                margin: {xs: '5%', md: '2%'},
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fill, minmax(min(300px, 100%), 1fr))',
                                gap: 2
                            }}
                        >
                            {productList.map((card, _index) => (
                                <Card key={card.id} sx={{ borderRadius: '20px', display: 'flex', flexDirection: 'column' }}>
                                    <CardActionArea onClick={() => navigate("/adminDetail", { state: { productId: card?.uuid } }) }>
                                        {card.images.length === 0 ?
                                            <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden' }}>
                                                <Box
                                                    component="img"
                                                    sx={{
                                                        height: 200,
                                                        width: '100%',
                                                        objectFit: 'cover',
                                                        display: 'block'
                                                    }}
                                                    src={Image.NoImage}
                                                />
                                            </Paper>
                                        :
                                            <Carousel
                                                animation="slide"
                                                indicators={true}
                                                navButtonsAlwaysVisible={false}
                                            >
                                                {card.images.map((item, _) => (
                                                    <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden' }}>
                                                        <Box
                                                            component="img"
                                                            sx={{
                                                                height: 200,
                                                                width: '100%',
                                                                objectFit: 'cover',
                                                                display: 'block'
                                                            }}
                                                            src={item.url}
                                                        />
                                                    </Paper>
                                                ))}
                                            </Carousel>
                                        }
                                        <CardContent>
                                            <Typography gutterBottom variant="h5" component="div" sx={{ textAlign: "end", margin: "5px" }}>
                                                {card.estatus === 'en_venta' ?
                                                    <Chip sx={{ color: 'white', fontWeight: 500 }} color="warning" label="En venta" />
                                                :
                                                    <>
                                                        {card.estatus === 'registrado' ?
                                                            <Chip sx={{ color: 'white', fontWeight: 500 }} color="success" label="Registrado" />
                                                        :
                                                            <Chip sx={{ color: 'white', fontWeight: 500 }} color="error" label="Vendido" />
                                                        }
                                                    </>
                                                }
                                            </Typography>
                                            <Typography gutterBottom variant="h5" component="div">
                                                {card.descripcion_corta}
                                            </Typography>
                                            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                                {card.descripcion_larga.substring(0, 100)}...
                                            </Typography>
                                            <Typography variant="body3" color="text.secondary" paragraph textAlign='end'>
                                                <b>Precio:</b> {currencyFormat.format(parseFloat(card.precio_venta) || 'Por definir')}<br />
                                                {formatCifra(card.piezas)} pzas.<br />
                                                <small style={{color: "#969696"}}>({formatCifra(card.vendidos)} pzas. vendidas)</small><br />
                                            </Typography>
                                        </CardContent>
                                    </CardActionArea>
                                </Card>
                            ))}
                        </Box>
                    :
                        <Typography
                            variant="h2"
                            component="div"
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                color: 'dimgray',
                                fontFamily: 'Barlow',
                                height: '70vh',
                                placeItems: 'center'
                            }}
                        >
                            Sin productos disponibles
                        </Typography>
                    }
                </>
            }
        </Box>
    )
}

export default CommonAdminViewPage;
